import conferanceHome from '../assets/images/conferance/star1.png';
import mathMagecian from '../assets/images/mathMagecian/culc.png';
import portfolio from '../assets/images/portfolio/portfolio1.png';
import myCv from '../assets/images/elham_cv_v5.pdf'
import recipe from '../assets/images/recipe/recipe.png';
import lp1 from '../assets/images/landingPage/l1.png';
import lp2 from '../assets/images/landingPage/l2.png';
import codeAlpha from '../assets/images/codeAlpha/rb.png';
import reactTodo from '../assets/images/reactTodo/reactTodo.png';
export const images = {
  conferance:[conferanceHome],
  mathMagecian:[mathMagecian],
  portfolio: [portfolio],
  recipe: [recipe],
  myCv: myCv,
  lp: [lp1,lp2],
  codeAlpha: [codeAlpha],
  reactTodo: [reactTodo]
};